import NewAccountFormConfiguration from "../models/NewAccountFormConfiguration";

export default class NewAccountFormConfigurationMapper {
    public map(data: any): NewAccountFormConfiguration {
        const configuration: NewAccountFormConfiguration = new NewAccountFormConfiguration();
        configuration.title = data.Title;
        configuration.description = data.Description;
        configuration.firstnameLabel = data.FirstnameLabel;
        configuration.firstnamePlaceholder = data.FirstnamePlaceholder;
        configuration.lastnameLabel = data.LastnameLabel;
        configuration.lastnamePlaceholder = data.LastnamePlaceholder;
        configuration.emailLabel = data.EmailLabel;
        configuration.emailPlaceholder = data.EmailPlaceholder;
        configuration.fileToLargeValidationMessage = data.FileToLargeValidationMessage;
        configuration.fileLabel = data.FileLabel;
        configuration.filePlaceholder = data.FilePlaceholder;
        configuration.identitycardLabel = data.IdentitycardLabel;
        configuration.identycardExtraInformation = data.IdentycardExtraInformation;
        configuration.identityCardAddFileLabel = data.IdentityCardAddFileLabel;
        configuration.identityCardDragFileLabel = data.IdentityCardDragFileLabel;
        configuration.consentLabel = data.ConsentLabel;
        configuration.sendButton = data.SendButton;
        configuration.redirectPageURL = data.RedirectPageURL;
        configuration.privacyPageURL = data.PrivacyPageURL;
        configuration.privacyPageLabel = data.PrivacyPageLabel;
        configuration.fileUploadAllowedFormatsLabel = data.FileUploadAllowedFormatsLabel;

        return configuration;
    }

}